import {
    blockSenderSucceededNotificationText,
    viewBlockedSendersButtonText,
} from './showNotificationOnBlockSenders.locstring.json';
import { blockSendersButtonText } from '../../strings.locstring.json';
import loc, { format } from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';
import { getListViewNotificationDimensions } from 'owa-mail-layout';
import { lazyShowNotification, NotificationBarCallbackReason } from 'owa-notification-bar';
import { lazyMountAndShowFullOptions } from 'owa-options-view';

/**
 * show notification on delete
 * @param numberOfItems acted on for the block action
 */
export default function showNotificationOnBlockSenders(numberOfItems: number) {
    const notificationText =
        numberOfItems === 1
            ? loc(blockSenderSucceededNotificationText)
            : format(loc(blockSendersButtonText), numberOfItems);
    const notificationDimensions = getListViewNotificationDimensions();

    lazyShowNotification.importAndExecute(
        'blockSenderNotification',
        'MailModuleNotificationBarHost',
        notificationText,
        {
            icon: ControlIcons.Blocked,
            primaryActionText: loc(viewBlockedSendersButtonText),
            // Want 12 px of padding on either side of the notificaiton bar
            minWidth: notificationDimensions.minWidth,
            maxWidth: notificationDimensions.maxWidth,
            notificationCallback: reason => {
                if (reason === NotificationBarCallbackReason.PrimaryActionClicked) {
                    lazyMountAndShowFullOptions.importAndExecute('mail', 'junkEmail');
                }
            },
        }
    );
}
